import { booleanValid } from '@turf/turf';
import type {
  Feature,
  Geometry,
  GeometryCollection,
  LineString,
  MultiLineString,
  MultiPolygon,
  Polygon,
} from 'geojson';

const VALID_GEOMETRY_TYPES = ['Polygon', 'MultiPolygon', 'LineString', 'MultiLineString', 'GeometryCollection'];

export type ValidKMZProjectGeometry = MultiPolygon | Polygon | LineString | MultiLineString | GeometryCollection;

export function isValidKMZProjectFeature(
  feature: Feature<Geometry | null>,
): feature is Feature<ValidKMZProjectGeometry> {
  if (
    // if geometry exists
    !!feature.geometry &&
    // if geometry type is is matching type above
    VALID_GEOMETRY_TYPES.includes(feature.geometry.type) &&
    // if geometry is valid
    booleanValid(feature)
  ) {
    return true;
  }

  return false;
}
